import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';

import { ModalDialog } from 'bookingform';
import {
  retrieveBudgetEmail, setFilterCurrency, setHotel, setCurrencies,
  setAgentCode,
  setRateType,
  setAgentSell,
  setAgentUseCoins,
} from '../../../actions/Booking';

import sandosLogo from '../../../static/images/SANDOS_logo_lg.png';
import marconfortLogo from '../../../static/images/MARCONFORT_logo_lg.png';
import palmaiaLogo from '../../../static/images/PALMAIARESORTS_logo_lg.png';
import {
  addSelectedRoomsToCart,
  updateCartContent,
  //updateCartContentAndRedirectToConfirmation,
} from '../../../actions/Cart';
import { initSession } from '../../../actions/Session';
import { getConversionRates } from '../../../actions/Loyalty';
import { store } from '../../../Store';
import withNavigate from '../../../withNavigate'; // Importa el HOC

const chainLogos = {
  SANDOS: sandosLogo,
  MARCONFORT: marconfortLogo,
  PALMAIARESORTS: palmaiaLogo,
};

class Budget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: '',
      isLoading: true,
      budgetExceededModalIsVisible: false,
    };

    this.componentWillMount = this.componentWillMount.bind(this);
    this.showBudgetExceededModal = this.showBudgetExceededModal.bind(this);
    this.toggleBudgetExceededModal = this.toggleBudgetExceededModal.bind(this);
    this.getUrlParams = this.getUrlParams.bind(this);
    this.renderBudgetExceededModal = this.renderBudgetExceededModal.bind(this);
    this.searchAvailability = this.searchAvailability.bind(this);
    this.retrieveBudget = this.retrieveBudget.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  async componentWillMount() {
    if (!this.props.hasSession) {
      this.props.initSession().then(() => {
        this.retrieveBudget();
      });
    } else if (this.props.params.token) {
      this.retrieveBudget();
    } else {
      this.setState({ errorMessages: this.context.t('Couldn\'t retrieve budget') });
    }
  }

  retrieveBudget() {
    this.props.retrieveBudgetEmail(this.props.params.token).then((response) => {
      this.availability = response.availability;
      this.cart = response.cart;
      this.lang = response.lang;
      // Acá debemos de traer el valor de agentCode, rateType, agentUseCoins y agentSell desde la bd
      // y setearlos acá para que cuando carge el link tenga esa información seteada
      const state2 = store.getState();
      state2.bookingFormState.agentCode = response.agent_code !== '-' ? response.agent_code : '';
      // Si el no viene agentCode, en bd guardamos un guión - y acá simplemente
      // si viene el guión, ponemos agentCode=''
      state2.bookingFormState.agentSell = response.agent_sell;
      state2.bookingFormState.rateType = response.rate_type;
      state2.bookingFormState.agentUseCoins = response.agent_use_coins;
      state2.bookingFormState.showDistributions = false;

      if (this.availability && this.cart) {
        this.props.dispatch(setLanguage(this.lang));
        this.props.dispatch(setHotel(response.cart.hotels[0]));
        // Había un error de que no había el array de currencies, entonces la siguiente línea
        // sirve para resolver ese tema
        const availHotel = { ...this.availability.availables[0] };
        this.props.dispatch(setCurrencies(availHotel.currencies));
        // Había un error de que no había los conversionRates dentro del objeto loyalty
        // La siguiente línea sirve para resolver ese tema
        this.props.dispatch(getConversionRates(availHotel.code));
        this.props.dispatch(setFilterCurrency(response.cart.hotels[0].currency));
        //Acá debemos enviar el budget token en caso de que haya
        // Acá metemos al objeto cart el campo budget_token que obtenemos en el response
        // del servicio retrieveBuget para luego en el confirmation form mandar ese campo
        // a la hora de guardar la booking
        // Con ésto se soluciona error de no mandar el token en la confirmación de la booking
        this.cart.budget_token = this.props.params.token;
        //this.props.dispatch(updateCartContentAndRedirectToConfirmation(this.cart, this.props.navigate));
        this.props.dispatch(updateCartContent(this.cart));
        this.props.dispatch(setAgentCode(response.agent_code !== '-' ? response.agent_code : ''));
        this.props.dispatch(setRateType(response.rate_type));
        this.props.dispatch(setAgentUseCoins(response.agent_use_coins));
        this.props.dispatch(setAgentSell(response.agent_sell));
        this.props.navigate('/confirmation/');
      } else {
        this.showBudgetExceededModal();
      }
    });
  }

  showBudgetExceededModal() {
    this.setState({ budgetExceededModalIsVisible: true });
  }

  toggleBudgetExceededModal() {
    this.setState({ budgetExceededModalIsVisible: !this.state.budgetExceededModalIsVisible });
  }

  getUrlParams(requestedInfo) {
    const state2 = store.getState();
    const agentCode = state2.bookingFormState.agentCode !== '' ? state2.bookingFormState.agentCode : '-';
    const { agentSell } = state2.bookingFormState;
    const { rateType } = state2.bookingFormState;
    const { agentUseCoins } = state2.bookingFormState;

    const distributionCode = requestedInfo.occupancy.join(',');
    const parameters = [
      'v3',
      'search',
      this.props.lang,
      'BOOKING',
      this.props.sessionId,
      requestedInfo.checkin,
      requestedInfo.checkout,
      'hotel',
      requestedInfo.hotels_pk[0],
      distributionCode,
      agentCode,
      rateType,
      agentSell,
      agentUseCoins,
    ];

    if (requestedInfo.promocode) {
      parameters.push(requestedInfo.promocode);
    }
    return `/${parameters.join('/')}/`;
  }

  renderBudgetExceededModal() {
    return (
            <ModalDialog
                    titleElement={<span
                            className="ml-1 share-header__title uppercase">{this.context.t('No Availability for this search')}</span>}
                    bodyElement={
                      <div
                              className="text-lg rounded-md bg-white p-6 leading-loose"
                      >
                        <p className="font-bold">
                          {this.context.t('The hotel has no rooms available for the selected dates. If you wish, you can try other dates, search again for another hotel or destination, or contact our call center.')}
                        </p>
                      </div>
                    }
                    clickHandler={this.searchAvailability}
                    isVisible
            />);
  }

  searchAvailability() {
    this.toggleBudgetExceededModal();
    this.props.navigate(this.getUrlParams(this.availability.requested_info));
  }

  render() {
    const { errorMessages } = this.state;
    return (<div className="p-5 text-center">
      {errorMessages.length !== 0 && <div
              className="p-10"
      >
        <h2 className="text-lg font-mono font-bold mb-2">
          {this.context.t('The budget link contains errors')}
        </h2>
        <small>{this.context.t('Please review and fix the following errors from the link')}:</small>
      </div>}
      {errorMessages.length === 0 && <div>
        {this.state.isLoading
        && (<div className="row Search">
          <div className="col-md-12">
            <img src={chainLogos[this.props.chain]} className="logo"/>
            <div className="loader-sandos">
              {this.context.t('Loading')}...
            </div>
            <h1>{this.context.t('Checking your budget')}</h1>
          </div>
          {this.state.budgetExceededModalIsVisible && this.renderBudgetExceededModal()}
        </div>)
        }
      </div>}

    </div>);
  }
}

Budget.propTypes = {
  availability: PropTypes.object,
  cart: PropTypes.object,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

Budget.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  chain: state.bookingFormState.chain,
  sessionId: state.bookingFormState.sessionId,
  destination: state.bookingFormState.destination,
  booking: state.booking,
  hasSession: state.bookingFormState.sessionId !== null,
});

const mapDispatchToProps = (dispatch) => ({
  retrieveBudgetEmail: (payload) => dispatch(retrieveBudgetEmail(payload)),
  addSelectedRoomsToCart: (payload) => dispatch(addSelectedRoomsToCart(payload)),
  initSession: (payload) => dispatch(initSession(payload)),
  setHotel: (payload) => dispatch(setHotel(payload)),
  setFilterCurrency: (payload) => dispatch(setFilterCurrency(payload)),
  dispatch,
});

const ConnectedBudget = connect(mapStateToProps, mapDispatchToProps)(Budget);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedBudget);
